export enum FormIds {
  AppointmentType = 'APPOINTMENT_TYPE',
  PatientDetail = 'PATIENT_DETAIL',
  PatientDetailPrimaryInsurance = 'PATIENT_DETAIL_PRIMARY_INSURANCE',
  PatientDetailSecondaryInsurance = 'PATIENT_DETAIL_SECONDARY_INSURANCE',
  ScheduleExam = 'SCHEDULE_EXAM',
  Insurance = 'INSURANCE',
  InsurancePlan = 'INSURANCE_PLAN',
  PersonalDataVisionInsurance = 'PERSONAL_DATA_VISION_INSURANCE',
  ContactInformation = 'CONTACT_INFORMATION',
  ContactInformation2 = 'CONTACT_INFORMATION_2',
  CustomPage = 'CUSTOM_PAGE',
  CustomFieldsPatient = 'CUSTOM_FIELDS_PATIENT',
  CustomFieldsInsurance = 'CUSTOM_FIELDS_INSURANCE',
  CustomFieldsMarketing = 'CUSTOM_FIELDS_MARKETING',
}
